<template>
  <div v-if="permission.is_readonly && got_feature('feature_delete_docs_ro')">
    <app-confirm-modal
        v-model="deleteDocumentDialog"
        :text-msg="deleteDocumentMsg"
        @confirm="confirmDeleteDocument()"
        @cancel="noDeleteDocument()"
    >
    </app-confirm-modal>
    <JobProgress v-model="deleteProgressState" :job_id="deleteJobId" v-on:done="deleteItemDone" >
      <template v-slot:progress>
        <v-btn class="mt-1" outlined fab small loading icon></v-btn>
      </template>
      <template v-slot:quiet>
        <v-btn
          class="mt-1"
          color="primary"
          :loading="deleting || Boolean(deleteJobId)"
          @click="confirmDialogDeleteDocument()"
          outlined
          fab
          small
        >
          <v-icon v-once>mdi-delete</v-icon>
        </v-btn>
      </template>
    </JobProgress>
  </div>
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { client } from "@/api/client";
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue';
import JobProgress from '../components/JobProgress.vue'

export default {
  name: "ShowDeleteDocBtn",
  props: {
  },
  data() {
    return {
      deleteDocumentDialog: false,
      deleteDocumentMsg: 'Se va a eliminar el documento.',
      deleteProgressState: 'none',
      deleteJobId: 0,
      deleting: false,
    };
  },
  components: {
    AppConfirmModal,
    JobProgress,
  },
  computed:{
    ...mapGetters('documents',['currentDocument']),
    ...mapGetters({
      permission: 'permissions/permission',
      got_feature: 'got_feature',
    }),
  },
  methods: {
    ...mapActions({
      setZoom: "documents/setZoom",
      doRotate: 'documents/doRotate',
      setMessageModal: 'messageModal/setModal',
      closeMessageModal: 'messageModal/closeModal',
    }),
    confirmDialogDeleteDocument() {
      this.deleteDocumentDialog = true;
    },
    noDeleteDocument() {
      this.deleteDocumentDialog = false;
    },
    confirmDeleteDocument() {
      this.deleteDocumentDialog = false;
      this.deleting = true;
      client.post("delete_documents/" , { 'doc_ids': [this.currentDocument.id] }).then(resp => {
        if (Object.keys(resp.data).includes('ko')) {
            this.setMessageModal({
              text: resp.data['ko'],
              actionConfirmButton: this.closeMessageModal
            })
            this.deleting = false;
            this.deleteDocumentDialog = false;
        }
        else {
          this.deleteJobId = resp.data['AsyncJob'];
          this.deleteProgressState = 'running';
        }
      });
    },
    deleteItemDone() {
      this.deleting = false;
      this.deleteJobId = 0;
      this.setMessageModal({
        text: 'El documento se ha borrado correctamente.',
        actionConfirmButton: this.closeMessageModal
      })
      if(!this.currentDocuments){
        this.$router.push({name:'document-list'});
      }
    },
  },
};
</script>

